import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import MiniFAQSection from './components/MiniFAQSection';
import CTASection from './components/CTASection';
import { addSchemaToPage, removePageSchemas, getLocalBusinessSchema, getServiceSchema, getBreadcrumbSchema } from '../../utils/seo';

const HomePage = () => {
  useEffect(() => {
    // Add Schema.org JSON-LD
    const schemas = [
      addSchemaToPage(getLocalBusinessSchema()),
      addSchemaToPage(getServiceSchema()),
      addSchemaToPage(getBreadcrumbSchema([
        { name: 'Inicio', url: '/' }
      ]))
    ];

    return () => {
      removePageSchemas();
    };
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <BenefitsSection />
        <TestimonialsSection />
        <ProcessSection />
        <ServiceAreasSection />
        <MiniFAQSection />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default HomePage;
